import React from "react";
import get from "lodash/get";
import Accordion from "react-bootstrap/Accordion";
import { buildAPIQuery } from "../../../utils/genericAPI";

import "./index.scss";

const APIView = ({
    index,
    pathValue,
    apiParams = {},
    formAttributeColumns = [],
}) => {
    let filteredFormAttributeColumns = formAttributeColumns.map((attr) => attr?.name);
    const query = buildAPIQuery(pathValue, apiParams, filteredFormAttributeColumns);
    const type = get(query, "type");
    const queryPayload = get(query, "payload");
    let payload = formAttributeColumns;
    payload = payload?.filter((item) => queryPayload?.[item?.name] !== undefined);
    

    return (
        <>
            <Accordion className={`my-3 table-generic-api ${type}`}>
                <Accordion.Item eventKey={index}>
                    <Accordion.Header>
                        <span className="method">{type}</span>
                        <span className="url">{get(query, "url")}</span>
                    </Accordion.Header>
                    <Accordion.Body>
                        Request parameters
                        <div style={{backgroundColor: "#000",padding: "10px",color: "#fff"}}>
                            { 
                                (queryPayload?.page >= 0 && queryPayload?.searchFilters) ?
                                        <pre className="p-3">
                                            {JSON.stringify(queryPayload, undefined, 2)}
                                        </pre>
                                        :
                                        payload?.length > 0 ?
                                            <>
                                                <p>{"{"}</p>
                                                    <div className="pl-3" style={{paddingLeft:"30px"}}>
                                                        {
                                                            payload.map((item) => (
                                                                <div key={item.name} className="d-flex align-items-center gap-2">
                                                                    <span style={{color: "#fff",fontSize:"14px"}}>{`"${ item.name}": "${item.type}"`}</span>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                <p>{"}"}</p>
                                            </>
                                            : <p>{"{}"}</p>
                            }

                        </div>

                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    );
};

export default APIView;
